import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';

import {NgbModule} from '@ng-bootstrap/ng-bootstrap';

import {FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {FormsModule} from '@angular/forms';
import {ProgramDetailsComponent} from './program-details.component';
import {ProgramService} from '../../../services/vpp/program.service';

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    NgbModule,
    FontAwesomeModule,
    FormsModule
  ],
  declarations: [
    ProgramDetailsComponent
  ],
  exports: [
    ProgramDetailsComponent
  ],
  providers: [
    ProgramService
  ]
})
export class ProgramDetailsModule { }
